<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Mobilization"
        [title]="title()"
        subtitle="Configure daily salary rules selected by truck type and effective date.">
        <div actions>
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="cancel()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="isSaving" (onClick)="save()"></p-button>
        </div>
    </app-page-hero>

    <form [formGroup]="form" class="form-grid">
        <div>
            <app-page-form-section icon="pi pi-truck" title="Rule Basis" subtitle="Choose the truck type and daily salary rate.">
                <div class="field-grid">
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-truck"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <p-select inputId="vehicleType" [options]="vehicleTypes" formControlName="vehicleType" optionLabel="name"
                                    [filter]="true" filterBy="name" appendTo="body" placeholder="Select truck type" styleClass="w-full"></p-select>
                                <label for="vehicleType">Truck Type</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <p-inputNumber inputId="dailyRate" formControlName="dailyRate" [min]="0" [minFractionDigits]="0" [maxFractionDigits]="2" styleClass="w-full"></p-inputNumber>
                                <label for="dailyRate">Daily Rate</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-money-bill"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <input id="currencyCode" pInputText formControlName="currencyCode" maxlength="3" placeholder="SAR" />
                                <label for="currencyCode">Currency</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-sort-amount-up"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <p-inputNumber inputId="priority" formControlName="priority" styleClass="w-full"></p-inputNumber>
                                <label for="priority">Priority</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                </div>
            </app-page-form-section>

            <app-page-form-section icon="pi pi-calendar" title="Validity" subtitle="Effective dates are optional; higher priority wins when rules overlap.">
                <div class="field-grid">
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <p-datePicker inputId="effectiveFrom" formControlName="effectiveFrom" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                                <label for="effectiveFrom">Effective From</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-calendar-clock"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <p-datePicker inputId="effectiveTo" formControlName="effectiveTo" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                                <label for="effectiveTo">Effective To</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-check-circle"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <p-select inputId="active" [options]="activeOptions" formControlName="active" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                                <label for="active">Active</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                    <div class="field" style="grid-column: 1 / -1;">
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
                            <p-iftalabel>
                                <textarea id="notes" pTextarea formControlName="notes" rows="4" placeholder="Rule notes"></textarea>
                                <label for="notes">Notes</label>
                            </p-iftalabel>
                        </p-inputgroup>
                    </div>
                </div>
            </app-page-form-section>
        </div>

        <aside class="summary-panel">
            <h2>Summary</h2>
            <div class="summary-row">
                <span>Truck Type</span>
                <strong>{{ selectedVehicleTypeName() }}</strong>
            </div>
            <div class="summary-row">
                <span>Daily Rate</span>
                <strong>{{ form.value.dailyRate ?? 0 }} {{ form.value.currencyCode || 'SAR' }}</strong>
            </div>
            <div class="summary-row">
                <span>Priority</span>
                <strong>{{ form.value.priority ?? 0 }}</strong>
            </div>
            <div class="summary-row">
                <span>Status</span>
                <strong>{{ form.value.active === false ? 'Inactive' : 'Active' }}</strong>
            </div>
        </aside>
    </form>
</app-page-shell>
